// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef640d7f","732":"6d452851","977":"1f7452dc"}[chunkId] + ".chunk.js";
};